import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { ModalService } from '@niceltd/sol/modal';
import { Subscription } from 'rxjs';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-user-idle',
    templateUrl: './user-idle.component.html',
    styleUrls: ['./user-idle.component.scss'],
})
export class UserIdleComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild('idleDialog') idleModal: TemplateRef<any>;
    @HostListener('document:mousemove', ['event'])
    onMouseMove(e) {
        this.onDismissed();
    }

    /** Whether the idle service should run. */
    @Input() isEnabled = false;
    /** Whether the component being watched is active. This should be used to ensure only one modal is shown at a time. */
    @Input() isActive = false;
    
    @Output() onIdleChange = new EventEmitter();
    private _subscriptions: Subscription[] = [];
    isIdle = false;
    idleTitle = "";
    idleMessage = "";
    idleDialogRef = null;

    constructor(
        private userIdle: UserIdleService,
        private solModalService: ModalService,
        private cvLocalizationService: CVLocalizationService,
    ){ }

    async ngOnInit() {
        await this.cvLocalizationService.GetSection("Dashboard_Idle");
        this.idleTitle = this.cvLocalizationService.getCachedText("Dashboard_Idle", "Idle_Title", "Dashboard Paused");
        this.idleMessage = this.cvLocalizationService.getCachedText(
            "Dashboard_Idle", 
            "Idle_Message", 
            "The dashboard has paused due to 20 minutes of inactivity. Move your cursor to resume updates."
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.isEnabled || changes.isActive) {
            if (
                (changes.isEnabled?.currentValue && this.isActive) || 
                (changes.isActive?.currentValue && this.isEnabled)
            ) {
                this.initIdle();
            }
            else {
                this.discardIdle();
            }
        }
    }

    initIdle() {
        this.userIdle.stopWatching();
        this.userIdle.resetTimer();
        this.userIdle.setConfigValues({ idle: 1200, timeout: 1, ping: 1 });
        this.userIdle.startWatching();
        this._subscriptions.push(this.userIdle.onTimerStart().subscribe());
        this._subscriptions.push(this.userIdle.onTimeout().subscribe(() =>  this.onTimeout()));
    }

    discardIdle() {
        this.userIdle.stopWatching();
        this.userIdle.stopTimer();
        this._subscriptions.forEach(sub => sub?.unsubscribe());
    }

    ngOnDestroy(): void {
        this.discardIdle();
    }

    openIdleModal() {
        this.solModalService.open(this.idleModal, { width: '420px' });
        this.idleDialogRef = this.solModalService.dialogRef;
    }

    onTimeout() {
        if (!this.isIdle) {
            this.userIdle.stopTimer();
            this.isIdle = true;
            this.onIdleChange?.emit(this.isIdle);
            if (this.isActive)
                this.openIdleModal();
        }
    }

    onDismissed() {
        if (this.isIdle || this.idleDialogRef != null) {
            this.userIdle.resetTimer();
            this.isIdle = false;
            this.onIdleChange?.emit(this.isIdle);
            if (this.isActive) {
                this.solModalService.close(true);
                this.idleDialogRef = null;
            }
        }
    }
}
